import Vue from 'vue'
import VueRouter from 'vue-router'
import Audit from '../views/Audit.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Audit',
    component: Audit
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
